import { useCallback, useEffect, useState } from "react";
import * as api from "./api";

export default function useConversationStats(conversationId) {
    const [stats, setStats] = useState();

    const reload = useCallback(() => {
        if (!conversationId) return;
        return api
            .getConversationStats(conversationId)
            .then((response) => setStats(response.data))
            .catch((err) => console.error(err));
    }, [conversationId]);

    useEffect(() => {
        reload();
    }, [reload]);

    return { stats, reload };
}
